import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './fa.js'

import { Path } from './utils'
import './styles/main.scss'
import '@/components'

Vue.prototype.$path = Path

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('FontAwesomeIcon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
